export default "__VITE_ASSET__2077d713__"